/*
 * @format
 */

import { put, takeLatest, all } from 'redux-saga/effects';

import * as types from '../action-types';
import jsonapi, {
  HALO_NOTIFICATION_MESSAGE,
  HALO_NOTIFICATION_MESSAGE_UNREAD_COUNT,
} from '../api/jsonapi';
import Logger from '../../components/Logger';

let jsonApi = null;
let abortController = null;

function* fetchMessages(action) {
  const callback = action?.callback;
  let callbackCalled = false;

  if (abortController) {
    abortController.abort();
  }

  const localController = new AbortController();
  abortController = localController;

  try {
    const response = yield jsonApi.findAll(HALO_NOTIFICATION_MESSAGE, {
      opts: { signal: localController.signal },
    });

    const data = response?.data;

    if (data) {
      yield put({
        type: types.HALO_NOTIFICATION_MESSAGES_RECEIVED,
        messages: data,
      });
    }

    if (callback) {
      callbackCalled = true;
      callback();
    }
  } catch (err) {
    Logger.error('Error fetching halo notification messages:', err);

    if (callback) {
      callbackCalled = true;
      callback(err);
    }
  } finally {
    // Abort the in-flight request when the saga is cancelled by takeLatest
    // or when it completes normally (abort on a completed request is a no-op).
    // This prevents orphaned HTTP requests from accumulating across
    // background/foreground cycles.
    localController.abort();

    if (abortController === localController) {
      abortController = null;
    }

    // Ensure callback is invoked even if the saga was cancelled by takeLatest.
    // Saga cancellation does not trigger the catch block, so without this the
    // caller's loading state would never be cleared.
    if (!callbackCalled && callback) {
      callback();
    }
  }
}

function* fetchUnreadCount() {
  try {
    const response = yield jsonApi.findAll(
      HALO_NOTIFICATION_MESSAGE_UNREAD_COUNT,
    );

    const count = response?.data?.[0]?.count ?? response?.data?.count ?? 0;

    yield put({
      type: types.HALO_NOTIFICATION_MESSAGES_UNREAD_COUNT_RECEIVED,
      count,
    });
  } catch (err) {
    Logger.error('Error fetching halo notification messages unread count:', err);
  }
}

function* fetchMessagesAndCount(action) {
  yield all([fetchMessages(action), fetchUnreadCount()]);
}

function* haloNotificationMessages(params) {
  jsonApi = params?.jsonApi || jsonapi();

  yield takeLatest(
    [
      types.WEBSOCKET_HELLO_MESSAGE_RECEIVED,
      types.HALO_NOTIFICATION_MESSAGES_INIT,
      types.HALO_NOTIFICATION_MESSAGES_FETCH,
    ],
    fetchMessagesAndCount,
  );
}

export default haloNotificationMessages;
